import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showToast = (message, type = 'default', options = {}) => {
  const defaultOptions = {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'min-w-[320px] bg-white border border-gray-200 shadow-lg rounded-lg text-center',
    bodyClassName: 'p-0',
    ...options,
  };

  switch (type) {
    case 'success':
      return toast.success(message, {
        ...defaultOptions,
        className: '!bg-green-50 !text-green-800 border-l-4 !border-green-500',
        progressClassName: '!bg-green-500',
      });
    case 'error':
      return toast.error(message, {
        ...defaultOptions,
        className: '!bg-red-50 !text-red-800 border-l-4 !border-red-500',
        progressClassName: '!bg-red-500',
      });
    case 'info':
      return toast.info(message, {
        ...defaultOptions,
        className: '!bg-blue-50 !text-blue-800 border-l-4 !border-blue-500',
        progressClassName: '!bg-blue-500',
      });
    case 'warning':
      return toast.warning(message, {
        ...defaultOptions,
        className: '!bg-amber-50 !text-amber-800 border-l-4 !border-amber-500',
        progressClassName: '!bg-amber-500',
      });
    default:
      return toast(message, defaultOptions);
  }
};

export const ToastContainerWrapper = () => (
  <ToastContainer
    position="top-center"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="light"
    toastClassName="relative flex p-4 mb-4 min-w-[320px] bg-white border border-gray-200 shadow-lg rounded-lg text-center"
    bodyClassName="flex-grow p-0 m-0 w-full"
    progressClassName="!bg-blue-500"
    closeButton={({ closeToast }) => (
      <button 
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        onClick={closeToast}
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    )}
  />
);

export default showToast;
